<template>
	<div class="anjian">
		<div v-wechat-title="$route.meta.title"></div>
		<Card class='card-left'>
			<Menu mode="vertical" theme="light" :active-name="userInfo.menuList['tool']['children'][0].key" @on-select='menuItem'>
				<div v-for="(item,index) in userInfo.menuList['tool']['children']" :name="item.key" :key="index" >
					<MenuItem v-if="item.children.length == 0" :name="item.key" :key="index" >
						<img :src="iconList[index]" class="menuIcon"/>
						<span style="font-weight: bold;">{{item.name}}</span>
					</MenuItem>
					<Submenu v-else :name="item.key">
						<template slot="title">
							<img :src="iconList[index]" class="menuIcon"/>
							<span style="font-weight: bold;">{{item.name}}</span>
						</template>
						<MenuItem v-for="(value,key) in item.children" :name="item.key + '-' + value.key" :key="key">{{value.name}}</MenuItem>
					</Submenu>
				</div>
			</Menu>
		</Card>

		<div class='card-right-top'>
			<Card v-if="this.menuName == 'knowledgeBase'">
				<div style="background: white">
					<div class="m_b"  style="margin-bottom: 15px">
						<div  class="weight_word">知识库检索</div>
						<div class="yl-flex flex_center">
							<Input search placeholder="搜索资料名称" v-model="document.keyword" class="s_search_input"  />
							<div class="s_search" @click="loadData">检索</div>
						</div>
					</div>
					<div class="bg_f content_wrap">
						<div class="flex_between item_content hand"  v-for="(item, index) in document.list" :key="index">
							<div  class="flex_between item_wrap">
								<Icon type="logo-wordpress" class="logo-word"/>
								<div class="flex_one file_file">
									<p >{{item.name}}<span  class="grey_c"> &lt; <span v-if="item.ext_info.fstCate">{{item.ext_info.fstCate}}</span><span v-if="item.ext_info.sndCate">（{{item.ext_info.sndCate}}）</span> &gt; </span></p>
									<div  class="yl-flex time_wrap" style="margin-left: -10px;">
										<span class="time_wrap">上传时间:<span> {{item.created_at}}</span></span>
										<span class="time_wrap">{{item.username}}</span>
									</div>
								</div>
							</div>
							<div class="icon_wrap flex_between">
								<Icon type="ios-cloud-download" class="download" @click="toLocate" :data-url="item.ext_info.file"/>
							</div>
						</div>
					</div>
					<div class="pager">
						<Page :total="information.count" :current="information.page" size="small" show-elevator />
					</div>
				</div>
			</Card>
			<Card v-else-if="this.menuName == 'information'">
				<div style="background: white">
					<div class="flex_between m_b">
						<div  class="flex_between search">
							<Input search placeholder="搜索信息名称" v-model="information.keyword" class="information_search"  />
							<div class="same_heig s_search hand" @click="loadData">搜索</div>
						</div>
					</div>
					<div class="oneMain" v-for="(item,index) in information.list" :key="index">
						<p >{{item.name}}</p>
						<div class="yl-flex one">
							<div @click="toLocate" :data-url="value.ext_info.url" class="single hand" v-for="(value,key) in item.list" :key="key">
								<div class="img_wrap"><img  :src="value.ext_info.logo"></div>
								<div class="information-title">{{value.name}}</div>
							</div>
						</div>
					</div>
				</div>
				<div class="pager">
					<Page :total="information.count" :current="information.page" size="small" show-elevator />
				</div>
			</Card>
			<Card v-else>
				<div style="background: white">
					<div class="flex_between m_b">
						<div  class="flex_between search">
							<Input search placeholder="搜索资料名称" v-model="document.keyword" class="information_search"  />
							<div  class="same_heig s_search hand" @click="loadData">搜索</div>
							<div  class="red">资料仅供内部学习使用，严禁外泄，重则追究法律责任</div>
						</div>
						<div class="flex_between same_heig s_search hand" @click="()=>{uploadModal = true}">上传资料</div>
					</div>
					
					
					<div class="delegate yl-flex" v-if="sndMenuName == 'attorneyTmp'">
						<div @click="()=>{(attorneyTmp.active = tag.key) && (subMenuName = tag.key) && loadData();}" class="hand dele" :class="{'active': attorneyTmp.active == tag.key}" v-for="(tag,index) in attorneyTmp.category" :key="index">
							{{tag.name}}
						</div>
					</div>
					<div class="delegate yl-flex" v-if="sndMenuName == 'headCaseTmp'">
						<div @click="()=>{(headCaseTmp.active = tag.key) && (subMenuName = tag.key) && loadData();}" class="hand dele" :class="{'active': headCaseTmp.active == tag.key}" v-for="(tag,index) in headCaseTmp.category" :key="index">
							{{tag.name}}
						</div>
					</div>
					<div class="bg_f content_wrap">
						<div class="flex_between item_content hand"  v-for="(item, index) in document.list" :key="index">
							<div  class="flex_between item_wrap">
								<Icon type="logo-wordpress" class="logo-word"/>
								<div class="flex_one file_file">
									<p >{{item.name}}<span  class="grey_c"> &lt; <span v-if="item.ext_info.fstCate">{{item.ext_info.fstCate}}</span><span v-if="item.ext_info.sndCate">（{{item.ext_info.sndCate}}）</span> &gt; </span></p>
									<div  class="yl-flex time_wrap" style="margin-left: -10px;">
										<span class="time_wrap">上传时间:<span> {{item.created_at}}</span></span>
										<span class="time_wrap">{{item.username}}</span>
									</div>
								</div>
							</div>
							<div class="icon_wrap flex_between">
								<Icon type="ios-cloud-download" class="download" @click="toLocate" :data-url="item.ext_info.file"/>
							</div>
						</div>
					</div>
					<div class="pager">
						<Page :total="information.count" :current="information.page" size="small" show-elevator />
					</div>
				</div>
			</Card>
			<!--上传资料modal-->
			<Modal
					v-model="uploadModal"
					title="上传资料"
					@on-cancel="() => {uploadModal = false}"
					@on-ok="fileSubmit">
				<addFile ref="addFile" ></addFile>
			</Modal>
		</div>
	</div>
</template>

<script>
	import {
		getInformation,
		getDocument,
		uploadDocument
	} from '@/api/tools'
	import {mapActions, mapGetters} from 'vuex';
	import addFile from '../tool/addFile.vue';
	export default{
		name:"Tool",
		components:{addFile},
		computed:{
			...mapGetters(['userInfo', 'token'])
		},
		created() {
			this.initIcon();
		},
		mounted: function() {
			this.init();
			this.menuName = this.userInfo.menuList['tool']['children'][0].key;
			this.loadData();
		},
		data() {
			return {
				fileName: '',
				fileUrl: '',
				uploadModal: false,
				menuName: '', // 一级菜单
				sndMenuName: '', // 二级菜单
				subMenuName: '', // 三级菜单
				information: {
				},
				document: {
				},
				iconList: [],
				attorneyTmp: {
					'category': [
						{'name':'民事', 'key':'civil'},
						{'name':'刑事', 'key':'criminal'},
						{'name':'行政', 'key':'administration'},
						{'name':'非诉', 'key':'nonLitigation'},
						{'name':'其它', 'key':'other'},
					],
					active: 'civil'
				},
				headCaseTmp: {
					'category': [
						{'name':'民事诉讼', 'key':'civilArb'},
						{'name':'刑事诉讼', 'key':'criminalArb'},
						{'name':'行政复议/诉讼', 'key':'administrativeArb'},
						{'name':'劳动人事仲裁', 'key':'laborArb'},
						{'name':'商/海事仲裁', 'key':'maritimeArb'},
						{'name':'非诉/服务文书', 'key':'serviceDoc'},
						{'name':'其它', 'key':'other'},
					],
					active: 'civilArb'
				}
			}
		},
		methods: {
			...mapActions([
				'handleLogOut',
			]),
			initIcon() {
				let that = this
				this.userInfo.menuList.tool.children.forEach(function (row, index) {
					that.iconList[index] = require('../../assets/icons/tool/'+row.key+'.png');
				})
			},
			loadData() {
				let that = this;
				var token = that.token;
				if (that.menuName == 'information') {
					var page = that.information.page;
					var keyword = that.information.keyword;
					getInformation({token,page,keyword}).then(function (res) {
						res = res.data;
						if (res.code != 1) {
							that.$Message.warning(res.msg);
							if (res.code == -2) {
								that.handleLogOut();
								that.$router.push({
									name: 'login'
								})
							}
							return ;
						}
						that.information.count = res.count;
						that.information.list = res.data;
					});
				} else {
					var page = that.document.page;
					var keyword = that.document.keyword;
					var fstCate = that.menuName;
					var sndCate = that.sndMenuName;
					var thdCate = that.subMenuName;
					getDocument({token,page,keyword,fstCate,sndCate,thdCate}).then(function (res) {
						res = res.data;
						if (res.code != 1) {
							that.$Message.warning(res.msg);
							if (res.code == -2) {
								that.handleLogOut();
								that.$router.push({
									name: 'login'
								})
							}
							return ;
						}
						that.document.count = res.count;
						that.document.list = res.data;
					});
				}
			},
			toLocate(e) {
				var _url = 	e.currentTarget.dataset.url;
				window.open(_url);
			},
			init() {
				this.menuName = '';
				this.sndMenuName = '';
				this.subMenuName = '';
				this.information = {
					page: 1,
					count: 0,
					keyword: '',
					list: []
				};
				this.document = {
					page: 1,
					count: 0,
					keyword: '',
					list: []
				}
			},
			menuItem(e) {
				this.init();
				if (e.indexOf('-') != -1) {
					this.menuName = e.split('-')[0];
					this.sndMenuName = e.split('-')[1];
					if (this.sndMenuName == 'attorneyTmp') {
						this.subMenuName = this.attorneyTmp.active;
					} else if (this.sndMenuName == 'headCaseTmp') {
						this.subMenuName = this.headCaseTmp.active;
					}
				} else {
					this.menuName = e;
				}
				this.loadData();
			},
			uploadFile(e) {
				var that = this;
				if (e.code != 1) {
					that.$Message.warning(e.msg);
					return ;
				}
				that.fileUrl = e.data.url;
			},
			fileSubmit() {
				var that = this;
				var token = that.token;
				var name = that.$refs['addFile'].fileName;
				var file = that.$refs['addFile'].fileUrl;
				var fstCate = that.menuName;
				var sndCate = that.sndMenuName;
				var thdCate = that.subMenuName;
				uploadDocument({token,name,file,fstCate,sndCate,thdCate}).then(function (res) {
					res = res.data;
					if (res.code != 1) {
						that.$Message.warning(res.msg);
						if (res.code == -2) {
							that.handleLogOut();
							that.$router.push({
								name: 'login'
							})
						}
						return ;
					}
					that.$Message.success(res.msg);
					that.fileName = '';
					that.fileUrl = '';
					that.uploadModal = false;
					that.$refs['addFile'].clear();
					that.loadData();
				});
			}
		}
	}
</script>

<style>
	.weight_word {
		font-weight: 800;
		margin-bottom: 15px;
		text-align: center;
	}
	.yl-flex {
		display: flex;
	}
	.flex_center {
		justify-content: center;
	}
	.s_search_input{
		width: 80%; margin-right: 20px;
	}
	.s_search_input input {
		border-radius: 100px!important;
	}
	.s_search {
		height: 32px;
		line-height: 32px;
		font-size: 12px;
		padding: 0 20px;
		border-radius: 50px;
		background: #0092ff;
		color: #fff;
		display: inline-block;
	}
	.flex_between {
		align-items: center;
		display: flex;
		justify-content: space-between;
		margin-bottom: 10px;
	}
	.content_wrap {
		padding: 10px 20px;
	}
	.content_wrap .logo-word{
		width: 40px;
		margin-right: 10px;
		color: #0092ff !important;
		font-size: 40px
	}
	.flex_one {
		flex: 1;
	}
	.file_file {
		font-size: 13px;
		color: #666;
	}
	.grey_c {
		color: #999;
	}
	.file_file .time_wrap {
		color: #accbe1!important;
		transform: scale(.95);
		margin-right: 10px;
	}
	.download {
		font-size: 20px; color: #0092ff
	}
	.oneMain {
		border-bottom: 1px solid #eee;
	}
	.oneMain p{
		padding: 20px 0;
		font-size: 16px;
	}
	.one{
		flex-wrap: wrap;
	}
	.one .single {
		width: 130px;
		text-align: center;
		margin: 0 30px 20px 0;
	}
	.img_wrap {
		padding: 5px;
		width: 100%;
		height: 130px;
		border: 1px solid #ccc;
		border-radius: 3px;
	}
	.img_wrap img {
		width: 100%;
		height: 100%;
	}
	.information-title {
		margin: 10px 0;
		font-size: 12px;
		display: flex;
		justify-content: center;
	}
	.information_search {
		width: 130px;
		margin:0 3px;
	}
	.information_search input {
		border-radius: 100px!important;
	}
	.hand {
		cursor: pointer;
	}
	.red {
		color: red;
	}
	.same_heig {
		height: 32px;
		font-size: 12px;
		padding: 0 20px;
		border-radius: 50px;
		line-height: 32px;
		margin:0 3px;
	}
	.inline {
		display:inline-block;
	}
	.upload-text {
		display:inline-block; width: 120px; padding-top: 10px; color: #54A1F3; font-size: 13px
	}
	.delegate {
		align-items: flex-end;
	}
	.dele {
		font-size: 12px;
		padding: 0 25px;
		border: 1px solid #e0e2e6;
		color: #666;
		border-top-left-radius: 10px;
		border-top-right-radius: 10px;
	}
	.dele.active {
		padding: 5px 20px;
		background: #0092ff;
		color: #fff;
	}
	.menuIcon{
		display: inline-block;
		width: 15px;
		height: 15px;
		vertical-align: middle;
		margin-bottom: 3px;
		margin-right: 5px;
	}
</style>